import AppStateManager from "@toothfairy/shared-ui/AppStateManager";

import AppToast from "@toothfairy/shared-ui/AppToast";
import React, { useCallback } from "react";
import workspacesHelper from "../../API/Workspaces/workspacesHelper";
import { SectionsProvider } from "../../Hooks/useSections";
import useWorkspaces from "../../Hooks/useWorkspaces";
import { useAdminMenuItems } from "../../Hooks/useSectionMenuItems";
import AdminScreen from "./AdminScreen";
import { useTranslation } from "react-i18next";
import usePath from "../../Hooks/usePath";
import { useHistory } from "../../Router";
import AccessDeniedScreen from "../AccessDenied";

const AdminScreenContainer = () => {
  const {
    updateWorkspaceInContext,
    getLastTabSelectedByScreen,
    handleSectionSelection,
  } = useWorkspaces();
  const { params } = usePath();
  const history = useHistory();
  const AppToasty = AppToast.useToast();
  const { state } = AppStateManager.useAppStateManager();
  const { getActiveWorkspace, isUserAdmin, isToothFairyStaff } =
    useWorkspaces();

  const { t } = useTranslation();
  let _defaultView;
  if (params.sectionId && (isUserAdmin() || isToothFairyStaff())) {
    _defaultView =
      params.sectionId?.toUpperCase() ||
      getLastTabSelectedByScreen("admin", "WORKSPACE_SETTINGS");
  }

  const adminMenuItems = useAdminMenuItems();
  const optionsDataGenerator = useCallback(
    () => adminMenuItems,
    [adminMenuItems]
  );
  const handleWorkspaceUpdate = async (property, value) => {
    try {
      const result = await workspacesHelper.updateWorkspace(
        state?.activeWorkspaceID,
        [{ property, value }]
      );
      updateWorkspaceInContext(result);
      AppToasty.show(t("WorkspaceUpdateCaption"), {
        type: "success",
      });
    } catch (error) {
      AppToasty.show(t("WorkspaceUpdateFailedCaption"), {
        type: "danger",
      });
      console.error("An error occured while updating the workspace", error);
    }
  };
  return _defaultView ? (
    <SectionsProvider
      sectionsWidth={"100%"}
      optionsDataGenerator={optionsDataGenerator}
      defaultViewUID={_defaultView}
      onDisplayedViewChanged={(section) => {
        handleSectionSelection(section, "admin");
        if (state.activeWorkspaceID && section) {
          const target = `/workspaces/${
            state.activeWorkspaceID
          }/admin/${section.toLowerCase()}`;
          if (history.location?.pathname !== target) history.push(target);
        }
      }}
      sectionsMainTitle={t("admin.menu.workspaceAdmin")}
    >
      <AdminScreen
        workspace={state?.workspaces?.find(
          (u) => u?.id === state?.activeWorkspaceID
        )}
        handleWorkspaceUpdate={handleWorkspaceUpdate}
      />
    </SectionsProvider>
  ) : (
    <></>
  );
};

export default AdminScreenContainer;
